import TabsForProfile from './TabsForProfile'

export default TabsForProfile